import classes from "./ThemeButton.module.scss";

const ThemeButton = (props) => {
  const { isDark, themeHandler } = props;
  return (
    <div
      className={classes.themeButton}
      onClick={() => themeHandler()}
      style={{ backgroundColor: isDark ? "#fefefe" : "#090916" }}
    >
      <div
        className={classes.themeButton_square}
        style={{
          backgroundColor: isDark ? "#090916" : "#fefefe",
          transform: isDark
            ? "translate(-50%, -50%)"
            : "translate(-50%, -50%) rotate(-360deg)",
        }}
      ></div>
      <div
        className={[
          classes.themeButton_square,
          classes.themeButton_square_2,
        ].join(" ")}
        style={{
          backgroundColor: isDark ? "#090916" : "#fefefe",
          transform: isDark
            ? "translate(-50%, -50%) rotate(45deg)"
            : "translate(-50%, -50%) rotate(-405deg)",
        }}
      ></div>
      <div
        className={classes.themeButton_circle}
        style={{ backgroundColor: isDark ? "#fefefe" : "#090916" }}
      ></div>
      <div
        className={[
          classes.themeButton_circle,
          classes.themeButton_circle_2,
        ].join(" ")}
        style={{
          backgroundColor: isDark ? "#090916" : "#fefefe",
          transform: isDark
            ? "translate(-50%, -50%)"
            : "translate(-100%, -50%)",
        }}
      ></div>
    </div>
  );
};

export default ThemeButton;
